import React from 'react';
import { changeTextProperties, changeIsNewShape, selectShape } from '../../../actions/CurrentSlideActions';
import { InteractiveShape } from '../interactive/InteractiveShape';
import thoughtBubbleUtils from './utils/ThoughtBubbleUtils';
import properties from '../../../constants/Properties';
import textSizeUtils from '../../utils/TextSizeUtils';
import platformDetection from '../../../components/utils/PlatformDetection';
import previewCommands from '../../utils/PreviewCommands';
import touchUtils from '../../utils/TouchUtils';
import animationManager from '../../utils/AnimationManager';
import saveManager from '../../utils/SaveManager';
import { showTextEditor, hideMenus, setContextTarget } from '../../../actions/MenuActions';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';
import createShapes from '../../utils/CreateShapes';
import appParameters from '../../utils/AppParameters';
import storeManager from '../../../store/StoreManager';
import menuType from '../../../constants/MenuType';
import localesManager from '../../../locales/LocalesManager';
import modeType from '../../../constants/ModeConstants';
import mouseUtils from "../../utils/MouseUtils";


export const ThoughtBubble = React.createClass({
    propTypes: {
        shapeModel: React.PropTypes.object
    },
    getInitialState() {
        return {
            isTextHeightUpdated: false
        };
    },
    componentWillReceiveProps(nextProps) {
        if (previewCommands.isPlayMode() == true)
            return;

        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !platformDetection.isIOS()) // shape becomes unselected
            this.clearTextSelection();

        if (!platformDetection.isTouchableDevice())
            return;

        const { shapeModel } = this.props;

        if (platformDetection.isIOS()) {
            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected)
                return;

            if (shapeModel.isNew) {
                this.changeFocus(true);
                return;
            }
        }

        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
                if (platformDetection.isIOS() && touchUtils.isLongInteraction() == true)
                    return;

                this.changeFocus(true);
            }
        }

        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
            this.changeFocus(false);
    },
    clearTextSelection() {
        if (this.refs.shapeTextArea)
            this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
    },
    changeFocus(isFocus) {
        if (platformDetection.isIOS()) {
            if (isFocus && !animationManager.isAnimationMode())
                this.props.dispatch(showTextEditor(this.props.shapeModel));

            return;
        }

        var view = this.refs.shapeTextArea;

        if (view) {
            if (isFocus == true)
                this.addFocus();
            else
                view.blur();
        }
    },
    addFocus() {
        var view = this.refs.shapeTextArea;

        if (view)
            view.focus();
    },
    onChangeText(e) {
        if (previewCommands.isPlayMode() || platformDetection.isIOS())
            return;

        const newValue = e.target.value;

        if (newValue == undefined)
            return;

        this.props.dispatch(changeTextProperties(this.props.shapeModel, 'htmlText', newValue));
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();

        var isTextAdded = false;

        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10)
            isTextAdded = true;

        setTimeout(this.checkSize, 50, isTextAdded);
    },
    checkIfIsNewShape() {
        if (previewCommands.isPlayMode())
            return;

        const { shapeModel} = this.props;

        if (shapeModel.isNew == true)
            setTimeout(this.setTextAreaFocus, 10);
    },
    setTextAreaFocus() {
        const { shapeModel, dispatch } = this.props;
        dispatch(changeIsNewShape(shapeModel.uuid, false));

        if (!platformDetection.isIOS())
            this.addFocus();
    },
    checkTextHeight() {
        const { shapeModel } = this.props;

        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
            setTimeout(this.updateTextSize, 20);
        }
    },
    updateTextSize() {
        this.setState({
            isTextHeightUpdated: true
        });

        this.checkSize();
    },
    checkSize(isTextAdded = false) {
        const { shapeModel, dispatch } = this.props;
        textSizeUtils.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
    },
    onTextAreaClick() {
        if (storeManager.getState().menu.contextMode == modeType.SIZE_AND_POSITION_CONTEXT)
            return;

        createShapes.checkFontMenu(this.props.dispatch, this.props.shapeModel);
    },
    isShapeSelected() {
        const currentSlide = storeManager.getState().currentSlide;

        if (currentSlide && currentSlide.model && currentSlide.model.content) {
            const shapes = currentSlide.model.content;
            var i;

            for (i = 0; i < shapes.length; i++)
                if (shapes[i].uuid == this.props.shapeModel.uuid) {
                    if (shapes[i].isSelected == true)
                        return true;
                    else
                        return false;
                }

            return false;
        }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;

            this.checkTextLabel(false);
        } else
            this.checkTextLabel(true);
    },
    checkTextLabel(show = false) {
        setTimeout(function() {
            var textLabelElement = document.getElementById('textBoxLabel');

            if (textLabelElement) {
                if (show)
                    textLabelElement.style.display = 'block';
                else
                    textLabelElement.style.display = 'none';
            }
        }.bind(this), 10);
    },
    onFocusTextArea() {
        if (document.activeElement == this.refs.shapeTextArea)
            this.checkTextLabel(true);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render() {
        this.checkIfIsNewShape();
        this.checkTextHeight();

        const { shapeModel, dispatch } = this.props;

        let x = shapeModel.x;
        let y = shapeModel.y;
        const PADDING = properties.TEXT_PADDING;
        const INNER_PADDING = properties.TEXT_INNER_PADDING;
        const bold = shapeModel.fontBold ? 'bold' : 'normal';
        const italic = shapeModel.fontItalic ? 'italic' : 'normal';
        const textProperties = textSizeUtils.textProperties(shapeModel);
        const EXTRA_PADDING = textProperties.extraPadding;

        var textAreaStyle = {
            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
            resize: 'none',
            overflow: 'hidden',
            padding: INNER_PADDING,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: shapeModel.fontFamily,
            fontSize: shapeModel.fontSize,
            fontStyle: italic,
            fontWeight: bold,
            color: shapeModel.fontColor,
            textAlign: shapeModel.fontAlign,
            wordSpacing: textProperties.wordSpacing,
            letterSpacing: textProperties.letterSpacing,
            textIdent: textProperties.textIdent
        };

        if (textProperties.lineHeight != -1)
            textAreaStyle.lineHeight = textProperties.lineHeight;

        if (shapeModel.fontUnderline)
            textAreaStyle.textDecoration = 'underline';

        let path = '';
        let points;
        let radius;

        if (!shapeModel.path) {
            path = thoughtBubbleUtils.getPath(shapeModel);
            shapeModel.path = path;
        } else {
            path = shapeModel.path;
        }

        let stemObject = thoughtBubbleUtils.getStemPoints(shapeModel);
        points = stemObject.points;
        radius = stemObject.radius;

        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var readOnlyValue = false;
        let clone = animationManager.getCloneByUid(shapeModel.uuid);

        if (!clone)
            clone = animationManager.clone;

        if (platformDetection.isIOS() || (clone && shapeModel.uuid == clone.uuid) || (animationManager.target && shapeModel.uuid == animationManager.target.uuid) || appParameters.isCartoonistPlayer()) {
            readOnlyValue = true;
            textAreaStyle.cursor = 'default';
        }

        var arabic = /[\u0600-\u06FF]/;

        if (arabic.test(shapeModel.htmlText))
            textAreaStyle.direction = 'rtl';

        var shapeIndex = createShapes.getShapeIndex(shapeModel.uuid);
        var ariaLabelValue = localesManager.getCaption('tekst', 'other') + ' ' + shapeIndex;
        var textAreaId = 'text_area_' + shapeModel.uuid;
        var tabIndexValue;

        if (!this.isShapeSelected())
            tabIndexValue = -1;

        return (
            <InteractiveShape shapeModel={shapeModel} dispatch={dispatch} rotatable={true} isBubble={true} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${x} ${y})`} opacity={shapeModel.opacity}>
                    <ellipse
                        rx={radius[0]}
                        ry={radius[0]}
                        cx={points[0].x}
                        cy={points[0].y}
                        filter={shapeModel.filter}
                        fill={shapeModel.fill}
                        fillOpacity={backgroundOpacity}
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none"/>
                    <ellipse
                        rx={radius[1]}
                        ry={radius[1]}
                        cx={points[1].x}
                        cy={points[1].y}
                        filter={shapeModel.filter}
                        fill={shapeModel.fill}
                        fillOpacity={backgroundOpacity}
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none"/>
                    <ellipse
                        rx={radius[2]}
                        ry={radius[2]}
                        cx={points[2].x}
                        cy={points[2].y}
                        filter={shapeModel.filter}
                        fill={shapeModel.fill}
                        fillOpacity={backgroundOpacity}
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none"/>
                    <path
                        d={path}
                        filter={shapeModel.filter}
                        fill={shapeModel.fill}
                        fillOpacity={backgroundOpacity}
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none" />
                    <foreignObject  x={PADDING} y={PADDING} width={shapeModel.width - 2 * PADDING} height={shapeModel.height - 2 * PADDING}>
                        {
                            !shapeModel.isGrouped ?
                                <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                                : null
                        }
                        <textarea tabIndex={tabIndexValue} id={textAreaId} role='textbox' onFocus={this.onFocusTextArea} aria-label={ariaLabelValue} aria-multiline='true' className='textShapes' ref='shapeTextArea' style={textAreaStyle} value={shapeModel.htmlText} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off' onTouchEnd={this.onTextAreaClick} onMouseUp={this.onTextAreaClick} onChange={this.onChangeText} readOnly={readOnlyValue}/>
                    </foreignObject>
                </g>
            </InteractiveShape>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/ThoughtBubble.js
 **/